// const dayEl = document.querySelector('.day');
// const hourEl = document.querySelector('.hour');
// const minuteEl = document.querySelector('.minute');
// const secondEl = document.querySelector('.second');

// function Countdown() {
//   if (!dayEl || !hourEl || !minuteEl || !secondEl) return;

//   const now = Date.now();
//   const countDate = new Date("August 14 2026 23:59:59 GMT-0400").getTime();
//   const gap = countDate - now;

//   const second = 1000;
//   const minute = second * 60;
//   const hour = minute * 60;
//   const day = hour * 24;

//   const textDay = Math.floor(gap / day);
//   const textHour = Math.floor((gap % day) / hour);
//   const textMinute = Math.floor((gap % hour) / minute);
//   const textSecond = Math.floor((gap % minute) / second);

//   const pad = (num, digits = 2) => String(num).padStart(digits, "0");

//   dayEl.textContent = pad(textDay);
//   hourEl.textContent = pad(textHour);
//   minuteEl.textContent = pad(textMinute);
//   secondEl.textContent = pad(textSecond);
// }

// Countdown();
// setInterval(Countdown, 1000);





//     const progress1 = document.querySelector('.progress1');
//     const progressBackground = document.querySelector('.progress-bg');
//     const progressBar = document.getElementById('progress-bar');
//     const transitionDuration = 750;

//     // Convert EST time based on UTC offset
//     function getNewYorkTime() {
//         const now = new Date();
//         const localTime = now.getTime();
//         const localOffset = now.getTimezoneOffset() * 60000;
//         const utcTime = localTime + localOffset;
//         const offsetEST = -5; // adjust for EDT
//         return new Date(utcTime + (3600000 * offsetEST));
//     }

//     const beginTime = new Date("June 01, 2026 00:00:00").getTime();
//     const endTime = new Date("August 14, 2026 23:59:59").getTime();
//     const fullDuration = endTime - beginTime;

//     // Get current progress value as a decimal (0.0 to 1.0)
//     function getProgressFraction() {
//         const now = getNewYorkTime().getTime();
//         return (now - beginTime) / fullDuration;
//     }

//     // Calculate progress width as a percent string
//     function calculateWidth(fraction) {
//         if (fraction <= 0) return '0%';
//         if (fraction >= 1) return '100%';
//         if (fraction * 100 < 60) return '0%'; // hidden under 60%
//         return (60 + (fraction * 40)) + '%';
//         // return (fraction * 100) + '%';
//     }

//     // Step 1: Animate once on load
//     function initProgressBar() {
//         const fraction = getProgressFraction();
//         // console.log("FRACTION OF TIME PASSED: " + fraction);
//         const width = calculateWidth(fraction);
//         // console.log("WIDTH TO GO TO: " + width);

//         if (fraction <= 0 || fraction >= 1 || fraction * 100 < 60) {
//             // console.log("current time is not within progress bar start and end times")
//             return;
//         }

//         setTimeout(() => {

//             // Grow Progress Bar
//             progressBackground.style.height = '8px';
//             progress1.style.height = '8px';

//             // Animate to current progress
//             setTimeout(() => {
//                 progress1.style.width = width;
//             }, 250);

//             // Start Live Updates Afterward
//             setTimeout(startLiveProgressUpdates, transitionDuration + 100);
//         }, 100);

//     }

//     // Step 2: Continuous updates after initial animation
//     function startLiveProgressUpdates() {
//         setInterval(() => {
//             const fraction = getProgressFraction();
//             const width = calculateWidth(fraction);

//             // Update width
//             // progress1.style.transition = 'none';
//             progress1.style.width = width;

//             // Reset transition after updating
//             requestAnimationFrame(() => {
//                 progress1.style.transition = 'width .75s ease-in-out';
//             });
//         }, 1000);
//     }

//     // Start the system
//     initProgressBar();



// window.addEventListener("DOMContentLoaded", () => {
//   const sideBar = document.getElementById("popUpTrigger");
//   const banners = document.querySelectorAll(".popUpTrigger");
//   const popup = document.getElementById("fs-popup");
//   const closeBtn = document.getElementById("exit-icon");
//   const copyBox = document.getElementById("copyBox");
//   const bonusCode = document.getElementById("bonusCode");
//   const successMsg = document.getElementById("successMsg");
//   let popupContent = '';
//   if (popup) {
//     popupContent = popup.querySelector(".bonus-popup-content");
//   }
//   // const popupContent = popup.querySelector(".bonus-popup-content");

//   let autoCloseTimeout = null; // track pending auto-close timer

//   // 🟢 Open popup
//   banners.forEach(banner => {
//     banner.addEventListener("click", () => {
//     clearTimeout(autoCloseTimeout); // prevent leftover timers
//     successMsg.classList.add("hidden"); // reset success message
//     popup.classList.remove("hidden");
//     popup.classList.add("show");
//   });
//   })



//   // banner.addEventListener("click", () => {
//   //   clearTimeout(autoCloseTimeout); // prevent leftover timers
//   //   successMsg.classList.add("hidden"); // reset success message
//   //   popup.classList.remove("hidden");
//   //   popup.classList.add("show");
//   // });

//   // Close popup with zoom-out animation
//   function closePopup() {
//     clearTimeout(autoCloseTimeout);            // stop any pending timer
//     successMsg.classList.add("hidden");        // ALWAYS hide success message

//     popup.classList.add("closing");            // fade overlay
//     popupContent.classList.add("closing");     // zoom-out content

//     setTimeout(() => {
//       popup.classList.remove("show", "closing");
//       popupContent.classList.remove("closing");
//     }, 300); // matches popupOut duration
//   }

//   // Close with X button
//   closeBtn.addEventListener("click", closePopup);

//   // Close by clicking outside
//   popup.addEventListener("click", (e) => {
//     if (e.target === popup) closePopup();
//   });

//   // Copy code → show success + auto-close
//   copyBox.addEventListener("click", async () => {
//     try {
//       await navigator.clipboard.writeText(bonusCode.textContent);

//       successMsg.classList.remove("hidden");

//       clearTimeout(autoCloseTimeout); // clear previous timer if any
//       autoCloseTimeout = setTimeout(() => {
//         closePopup();                 // this also hides the success message
//       }, 5000);

//     } catch (err) {
//       console.error("Clipboard copy failed:", err);
//     }
//   });
// });


// (function () {
//   const heroSelector = "[data-gp-home-hero]";

//   function parseBoolean(value, fallback) {
//     if (value === "true") return true;
//     if (value === "false") return false;

//     return fallback;
//   }

//   /*
//    * Future image slides can place their real URLs in:
//    *
//    * data-gp-src
//    * data-gp-srcset
//    * data-gp-srcset on <source>
//    *
//    * The browser will not receive those images until the slide is needed.
//    */
//   function activateDeferredPicture(slide, splide) {
//     if (!slide) return;

//     const picture = slide.querySelector("[data-gp-deferred-picture]");

//     if (!picture) return;

//     picture
//       .querySelectorAll("source[data-gp-srcset]")
//       .forEach(function (source) {
//         source.srcset = source.dataset.gpSrcset;
//         source.removeAttribute("data-gp-srcset");
//       });

//     const image = picture.querySelector("img[data-gp-src]");

//     if (image) {
//       image.addEventListener(
//         "load",
//         function () {
//           splide.refresh();
//         },
//         { once: true }
//       );

//       if (image.dataset.gpSrcset) {
//         image.srcset = image.dataset.gpSrcset;
//         image.removeAttribute("data-gp-srcset");
//       }

//       image.src = image.dataset.gpSrc;
//       image.removeAttribute("data-gp-src");
//     }

//     picture.removeAttribute("data-gp-deferred-picture");
//   }

//   function prepareNextSlide(slides, currentIndex, rewind, splide) {
//     const prepare = function () {
//       let nextIndex = currentIndex + 1;

//       if (nextIndex >= slides.length) {
//         if (!rewind) return;

//         nextIndex = 0;
//       }

//       activateDeferredPicture(slides[nextIndex], splide);
//     };

//     if ("requestIdleCallback" in window) {
//       window.requestIdleCallback(prepare, { timeout: 1200 });
//     } else {
//       window.setTimeout(prepare, 250);
//     }
//   }

//   function initializeHero(hero) {
//     if (hero.dataset.gpHeroInitialized === "true") return;
//     if (typeof window.Splide !== "function") return;

//     const slides = Array.from(
//       hero.querySelectorAll(".splide__slide")
//     );

//     if (!slides.length) return;

//     const hasOneSlide = slides.length === 1;

//     const rewind =
//       parseBoolean(hero.dataset.rewind, true) && !hasOneSlide;

//     const autoplay =
//       parseBoolean(hero.dataset.autoplay, true) && !hasOneSlide;

//     const arrows =
//       parseBoolean(hero.dataset.showArrows, true) && !hasOneSlide;

//     const pagination =
//       parseBoolean(hero.dataset.showTabs, true) && !hasOneSlide;

//     const interval =
//       Number.parseInt(hero.dataset.autoplayDelay, 10) || 6000;

//     hero.dataset.singleSlide = String(hasOneSlide);
//     hero.dataset.gpHeroInitialized = "true";

//     const splide = new window.Splide(hero, {
//       type: "slide",
//       perPage: 1,
//       perMove: 1,
//       autoHeight: true,

//       rewind: rewind,
//       rewindByDrag: rewind,

//       drag: !hasOneSlide,
//       arrows: arrows,
//       pagination: pagination,
//       paginationKeyboard: true,

//       autoplay: autoplay,
//       interval: interval,
//       pauseOnHover: true,
//       pauseOnFocus: true,
//       resetProgress: true,

//       speed: 500,
//       waitForTransition: false,

//       reducedMotion: {
//         speed: 0,
//         rewindSpeed: 0,
//         autoplay: "pause"
//       }
//     });

//     splide.on("mounted move", function (newIndex) {
//       const activeIndex = Number.isInteger(newIndex)
//         ? newIndex
//         : splide.index;

//       activateDeferredPicture(
//         slides[activeIndex],
//         splide
//       );

//       prepareNextSlide(
//         slides,
//         activeIndex,
//         rewind,
//         splide
//       );
//     });

//     splide.mount();
//   }

//   function initializeAllHeroes() {
//     if (typeof window.Splide !== "function") return false;

//     document
//       .querySelectorAll(heroSelector)
//       .forEach(initializeHero);

//     return true;
//   }

//   function waitForSplide(attempt) {
//     if (initializeAllHeroes()) return;
//     if (attempt >= 50) return;

//     window.setTimeout(function () {
//       waitForSplide(attempt + 1);
//     }, 100);
//   }

//   function start() {
//     waitForSplide(0);
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener(
//       "DOMContentLoaded",
//       start,
//       { once: true }
//     );
//   } else {
//     start();
//   }

//   document.addEventListener(
//     "shopify:section:load",
//     start
//   );
// })();


/*
 * ============================================================================
 * LGND101 HOME PAGE JAVASCRIPT
 * ============================================================================
 *
 * This asset controls the following homepage features:
 *
 * 1. LGND101 giveaway countdown
 * 2. Giveaway-period progress bar
 * 3. Bonus-code popup and clipboard interaction
 * 4. GemPages homepage hero carousel
 * 5. Deferred hero-slide image loading
 * 6. Full-width autoplay progress pagination
 *
 * Each feature is kept separate so that one system can be edited without
 * changing the others.
 */


/*
 * ============================================================================
 * 1. LGND101 GIVEAWAY COUNTDOWN
 * ============================================================================
 */

// const dayEl = document.querySelector(".day");
// const hourEl = document.querySelector(".hour");
// const minuteEl = document.querySelector(".minute");
// const secondEl = document.querySelector(".second");

// /*
//  * Calculate the remaining giveaway time and update the countdown display.
//  */
// function Countdown() {
//   /*
//    * Stop immediately if any required countdown element is missing.
//    *
//    * This prevents the script from generating an error on a page where the
//    * countdown markup has not been included.
//    */
//   if (!dayEl || !hourEl || !minuteEl || !secondEl) return;

//   /*
//    * Get the current time as a Unix timestamp in milliseconds.
//    */
//   const now = Date.now();

//   const countDate = new Date(
//     "August 14 2026 23:59:59 GMT-0400"
//   ).getTime();
//   const gap = countDate - now;
//   const second = 1000;
//   const minute = second * 60;
//   const hour = minute * 60;
//   const day = hour * 24;


//   const textDay = Math.floor(gap / day);
//   const textHour = Math.floor((gap % day) / hour);
//   const textMinute = Math.floor((gap % hour) / minute);
//   const textSecond = Math.floor((gap % minute) / second);

//   const pad = (num, digits = 2) => {
//     return String(num).padStart(digits, "0");
//   };

//   dayEl.textContent = pad(textDay);
//   hourEl.textContent = pad(textHour);
//   minuteEl.textContent = pad(textMinute);
//   secondEl.textContent = pad(textSecond);
// }

// Countdown();
// setInterval(Countdown, 1000);


/*
 * ============================================================================
 * 2. GIVEAWAY-PERIOD PROGRESS BAR
 * ============================================================================
 */

/*
 * Locate the visible progress fill.
 */
const progress1 = document.querySelector(".progress1");

/*
 * Locate the background track surrounding the progress fill.
 */
const progressBackground = document.querySelector(".progress-bg");

/*
 * Locate the overall progress-bar element.
 *
 * This reference is retained from the original asset in case it is used by
 * other homepage code or needed for future progress-bar behavior.
 */
const progressBar = document.getElementById("progress-bar");

/*
 * Duration, in milliseconds, of the progress-fill width transition.
 */
const transitionDuration = 750;

/*
 * Return the current time adjusted to the fixed offset used by the original
 * giveaway progress-bar system.
 *
 * Important:
 * This preserves the existing fixed -5 offset behavior from the original file.
 */
function getNewYorkTime() {
  /*
   * Create a Date object representing the current visitor time.
   */
  const now = new Date();

  /*
   * Get the visitor's current timestamp.
   */
  const localTime = now.getTime();

  /*
   * Convert the visitor's timezone offset to milliseconds.
   */
  const localOffset = now.getTimezoneOffset() * 60000;

  /*
   * Remove the visitor's local timezone offset to determine UTC time.
   */
  const utcTime = localTime + localOffset;

  /*
   * Preserve the original fixed Eastern Standard Time offset.
   */
  const offsetEST = -5;

  /*
   * Return the UTC time adjusted by the chosen Eastern offset.
   */
  return new Date(utcTime + 3600000 * offsetEST);
}

/*
 * Define the start of the full campaign period.
 */
const beginTime = new Date(
  "August 03, 2026 00:00:00"
).getTime();

/*
 * Define the end of the full campaign period.
 */
const endTime = new Date(
  "August 14, 2026 23:59:59"
).getTime();

/*
 * Calculate the complete campaign duration in milliseconds.
 */
const fullDuration = endTime - beginTime;

/*
 * Return the fraction of the campaign period that has elapsed.
 *
 * Examples:
 *
 * 0    = the campaign has just started
 * 0.5  = the campaign is halfway complete
 * 1    = the campaign has ended
 */
function getProgressFraction() {
  /*
   * Get the current timestamp using the existing campaign timezone logic.
   */
  const now = getNewYorkTime().getTime();

  /*
   * Divide elapsed campaign time by the full campaign duration.
   */
  return (now - beginTime) / fullDuration;
}

/*
 * Convert the elapsed campaign fraction into the displayed bar width.
 */
function calculateWidth(fraction) {
  /*
   * Prevent a campaign that has not begun from displaying progress.
   */
  if (fraction <= 0) return "0%";

  /*
   * Cap the completed campaign at 100%.
   */
  if (fraction >= 1) return "100%";

  /*
   * Keep the progress bar hidden until 60% of the campaign has elapsed.
   */
  if (fraction * 100 < 60) return "0%";

  /*
   * Once the 60% threshold is reached, map the full campaign fraction into the
   * final 40% of the visible bar.
   *
   * This preserves the calculation from the original asset.
   */
  return 60 + fraction * 40 + "%";

  /*
   * To display the literal elapsed percentage instead, the line above could be
   * replaced with:
   *
   * return fraction * 100 + "%";
   */
}

/*
 * Perform the progress bar's initial entrance animation.
 */
function initProgressBar() {
  /*
   * Do not initialize the system if its required markup is absent.
   */
  if (!progressBackground || !progress1) return;

  /*
   * Calculate the campaign's current progress.
   */
  const fraction = getProgressFraction();

  /*
   * Convert that fraction into the appropriate CSS width.
   */
  const width = calculateWidth(fraction);

  /*
   * Keep the progress bar hidden when:
   *
   * - The campaign has not started
   * - The campaign has ended
   * - Less than 60% of the campaign has elapsed
   */
  if (
    fraction <= 0 ||
    fraction >= 1 ||
    fraction * 100 < 60
  ) {
    return;
  }

  /*
   * Allow the initial page layout to render before expanding the bar.
   */
  setTimeout(() => {
    /*
     * Reveal the progress bar track and fill.
     */
    progressBackground.style.height = "15px";
    progress1.style.height = "15px";

    /*
     * Wait briefly before animating the fill to its current position.
     */
    setTimeout(() => {
      progress1.style.width = width;
    }, 250);

    /*
     * Begin live progress updates after the initial width animation finishes.
     */
    setTimeout(
      startLiveProgressUpdates,
      transitionDuration + 100
    );
  }, 100);
}

/*
 * Continue updating the campaign progress bar after its entrance animation.
 */
function startLiveProgressUpdates() {
  /*
   * Stop if the fill element is unavailable.
   */
  if (!progress1) return;

  /*
   * Recalculate the progress bar once per second.
   */
  setInterval(() => {
    /*
     * Get the current campaign fraction.
     */
    const fraction = getProgressFraction();

    /*
     * Convert the fraction into a CSS width.
     */
    const width = calculateWidth(fraction);

    /*
     * Update the visible progress fill.
     */
    progress1.style.width = width;

    /*
     * Restore the width transition on the browser's next rendered frame.
     */
    requestAnimationFrame(() => {
      progress1.style.transition =
        "width .75s ease-in-out";
    });
  }, 1000);
}

/*
 * Start the campaign progress-bar system.
 */
initProgressBar();


/*
 * ============================================================================
 * 3. BONUS-CODE POPUP
 * ============================================================================
 */

/*
 * Wait until the page markup has been parsed before locating and attaching
 * popup controls.
 */
window.addEventListener("DOMContentLoaded", () => {
  /*
   * Locate the original sidebar popup trigger.
   *
   * This reference is retained from the original file, although the current
   * event listener is applied to every element with the .popUpTrigger class.
   */
  const sideBar = document.getElementById("popUpTrigger");

  /*
   * Locate every element that should open the bonus popup.
   */
  const banners = document.querySelectorAll(".popUpTrigger");

  /*
   * Locate the popup overlay.
   */
  const popup = document.getElementById("fs-popup");

  /*
   * Locate the popup's X/close button.
   */
  const closeBtn = document.getElementById("exit-icon");

  /*
   * Locate the clickable box that copies the bonus code.
   */
  const copyBox = document.getElementById("copyBox");

  /*
   * Locate the element containing the actual bonus-code text.
   */
  const bonusCode = document.getElementById("bonusCode");

  /*
   * Locate the clipboard-copy success message.
   */
  const successMsg = document.getElementById("successMsg");

  /*
   * Store the popup's inner animated content element.
   */
  let popupContent = null;

  /*
   * Only search inside the popup if the popup exists.
   */
  if (popup) {
    popupContent = popup.querySelector(
      ".bonus-popup-content"
    );
  }

  /*
   * Store the ID of any pending automatic-close timer.
   *
   * This allows an old timer to be cancelled before starting a new one.
   */
  let autoCloseTimeout = null;

  /*
   * Close the popup with its existing fade and zoom-out animations.
   */
  function closePopup() {
    if (!popup || !popupContent || !successMsg) return;
    clearTimeout(autoCloseTimeout);
    successMsg.classList.add("hidden");
    popup.classList.add("closing");
    popupContent.classList.add("closing");
    setTimeout(() => {
      popup.classList.remove("show", "closing");
      popupContent.classList.remove("closing");
    }, 300);
  }

  /*
   * Attach an open action to every popup trigger.
   */
  banners.forEach((banner) => {
    banner.addEventListener("click", () => {
      /*
       * Do nothing if the required popup markup is unavailable.
       */
      if (!popup || !successMsg) return;

      /*
       * Prevent an earlier clipboard action from closing the newly opened
       * popup.
       */
      clearTimeout(autoCloseTimeout);

      /*
       * Reset the success message whenever the popup is opened.
       */
      successMsg.classList.add("hidden");

      /*
       * Remove the class that keeps the popup hidden.
       */
      popup.classList.remove("hidden");

      /*
       * Apply the visible/entrance-animation class.
       */
      popup.classList.add("show");
    });
  });

  /*
   * Close the popup when the X button is clicked.
   */
  if (closeBtn) {
    closeBtn.addEventListener("click", closePopup);
  }

  /*
   * Close the popup when the visitor clicks directly on the overlay outside
   * the inner popup content.
   */
  if (popup) {
    popup.addEventListener("click", (event) => {
      if (event.target === popup) {
        closePopup();
      }
    });
  }

  /*
   * Copy the bonus code when its copy box is clicked.
   */
  if (copyBox && bonusCode && successMsg) {
    copyBox.addEventListener("click", async () => {
      try {
        /*
         * Copy the displayed bonus-code text to the visitor's clipboard.
         */
        await navigator.clipboard.writeText(
          bonusCode.textContent
        );

        /*
         * Reveal the successful-copy message.
         */
        successMsg.classList.remove("hidden");

        /*
         * Cancel any older automatic-close timer.
         */
        clearTimeout(autoCloseTimeout);

        /*
         * Automatically close the popup five seconds after the successful
         * clipboard action.
         */
        autoCloseTimeout = setTimeout(() => {
          closePopup();
        }, 5000);
      } catch (error) {
        /*
         * Report clipboard permission or browser-support failures without
         * stopping the rest of the homepage script.
         */
        console.error(
          "Clipboard copy failed:",
          error
        );
      }
    });
  }
});


/*
 * ============================================================================
 * 4. GEMPAGES HOMEPAGE HERO
 * ============================================================================
 *
 * This feature is wrapped in an immediately invoked function expression.
 *
 * That keeps its internal variables and functions out of the global scope and
 * prevents them from conflicting with other theme or GemPages scripts.
 */

(function () {
  /*
   * Selector used to locate every homepage hero instance.
   */
  const heroSelector = "[data-gp-home-hero]";

  /*
   * Convert an HTML data-attribute string into a real Boolean value.
   *
   * If the value is neither "true" nor "false", return the supplied fallback.
   */
  function parseBoolean(value, fallback) {
    if (value === "true") return true;
    if (value === "false") return false;

    return fallback;
  }

  /*
   * Clamp a numeric value between a minimum and maximum.
   *
   * The pagination system uses this to ensure that progress never falls below
   * 0 or rises above 1.
   */
  function clamp(value, minimum, maximum) {
    return Math.min(
      Math.max(value, minimum),
      maximum
    );
  }

  /*
   * Activate an image that was intentionally deferred.
   *
   * Future image slides can place their real image URLs in:
   *
   * data-gp-src
   * data-gp-srcset
   * data-gp-srcset on a <source> element
   *
   * The browser will not request those images until this function activates
   * the relevant slide.
   */
  function activateDeferredPicture(slide, splide) {
    /*
     * Stop if no slide was supplied.
     */
    if (!slide) return;

    /*
     * Find a deferred <picture> element inside the slide.
     */
    const picture = slide.querySelector(
      "[data-gp-deferred-picture]"
    );

    /*
     * Stop if the slide's picture has already loaded or was not deferred.
     */
    if (!picture) return;

    /*
     * Move each deferred <source> srcset into its real srcset attribute.
     */
    picture
      .querySelectorAll("source[data-gp-srcset]")
      .forEach(function (source) {
        source.srcset = source.dataset.gpSrcset;
        source.removeAttribute("data-gp-srcset");
      });

    /*
     * Locate the deferred fallback <img>.
     */
    const image = picture.querySelector(
      "img[data-gp-src]"
    );

    /*
     * Activate the fallback image if it exists.
     */
    if (image) {
      /*
       * Refresh Splide once the newly activated image finishes loading.
       *
       * This allows autoHeight and other slide measurements to remain correct.
       */
      image.addEventListener(
        "load",
        function () {
          splide.refresh();
        },
        { once: true }
      );

      /*
       * Activate the image's responsive srcset when one was deferred.
       */
      if (image.dataset.gpSrcset) {
        image.srcset = image.dataset.gpSrcset;
        image.removeAttribute("data-gp-srcset");
      }

      /*
       * Activate the image's primary src URL.
       */
      image.src = image.dataset.gpSrc;
      image.removeAttribute("data-gp-src");
    }

    /*
     * Mark the picture as activated so it will not be processed again.
     */
    picture.removeAttribute(
      "data-gp-deferred-picture"
    );
  }

  /*
   * Prepare the next hero slide during an idle browser period.
   *
   * Preloading one slide ahead avoids requesting every hero image immediately
   * while still making the next transition feel instantaneous.
   */
  function prepareNextSlide(
    slides,
    currentIndex,
    rewind,
    splide
  ) {
    /*
     * Define the image-preparation work separately so it can run either through
     * requestIdleCallback or setTimeout.
     */
    const prepare = function () {
      /*
       * Start with the slide immediately following the current slide.
       */
      let nextIndex = currentIndex + 1;

      /*
       * Handle reaching the final slide.
       */
      if (nextIndex >= slides.length) {
        /*
         * Do not prepare the first slide when carousel rewinding is disabled.
         */
        if (!rewind) return;

        /*
         * When rewinding is enabled, prepare slide zero as the next slide.
         */
        nextIndex = 0;
      }

      /*
       * Activate the next slide's deferred image.
       */
      activateDeferredPicture(
        slides[nextIndex],
        splide
      );
    };

    /*
     * Use the browser's idle callback when supported so the preload work does
     * not compete with more important rendering work.
     */
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(prepare, {
        timeout: 1200
      });
    } else {
      /*
       * Use a short timeout as the fallback for browsers without
       * requestIdleCallback.
       */
      window.setTimeout(prepare, 250);
    }
  }

  /*
   * Initialize one GemPages homepage hero.
   */
  function initializeHero(hero) {
    /*
     * Do not initialize the same hero more than once.
     */
    if (
      hero.dataset.gpHeroInitialized === "true"
    ) {
      return;
    }

    /*
     * Wait to initialize until the Splide library is available.
     */
    if (typeof window.Splide !== "function") {
      return;
    }

    /*
     * Collect the hero's original slide elements.
     */
    const slides = Array.from(
      hero.querySelectorAll(".splide__slide")
    );

    /*
     * Do not initialize an empty hero.
     */
    if (!slides.length) return;

    /*
     * Determine whether the hero contains only one slide.
     */
    const hasOneSlide = slides.length === 1;

    /*
     * Enable rewinding only when requested and when multiple slides exist.
     */
    const rewind =
      parseBoolean(
        hero.dataset.rewind,
        true
      ) && !hasOneSlide;

    /*
     * Enable autoplay only when requested and when multiple slides exist.
     */
    const autoplay =
      parseBoolean(
        hero.dataset.autoplay,
        true
      ) && !hasOneSlide;

    /*
     * Enable arrows only when requested and when multiple slides exist.
     */
    const arrows =
      parseBoolean(
        hero.dataset.showArrows,
        true
      ) && !hasOneSlide;

    /*
     * Enable pagination only when requested and when multiple slides exist.
     *
     * Splide still creates the pagination buttons. CSS converts those buttons
     * into the custom full-width progress bars.
     */
    const pagination =
      parseBoolean(
        hero.dataset.showTabs,
        true
      ) && !hasOneSlide;

    /*
     * Read the autoplay duration from the hero's data attribute.
     *
     * Use 6000 milliseconds if the attribute is absent or invalid.
     */
    const interval =
      Number.parseInt(
        hero.dataset.autoplayDelay,
        10
      ) || 6000;

    /*
     * Expose the single-slide state to CSS.
     */
    hero.dataset.singleSlide =
      String(hasOneSlide);

    /*
     * Mark the hero as initialized before mounting Splide.
     */
    hero.dataset.gpHeroInitialized = "true";

    /*
     * Create the Splide carousel.
     */
    const splide = new window.Splide(hero, {
      /*
       * Use a standard slide carousel rather than cloned loop slides.
       */
      type: "slide",

      /*
       * Display one hero slide at a time.
       */
      perPage: 1,

      /*
       * Move one slide per navigation action.
       */
      perMove: 1,

      /*
       * Allow Splide to resize to match the current slide's height.
       */
      autoHeight: true,

      /*
       * Return to the first slide after the final slide when enabled.
       */
      rewind: rewind,

      /*
       * Allow drag navigation to rewind from the last slide to the first.
       */
      rewindByDrag: rewind,

      /*
       * Disable dragging when only one slide exists.
       */
      drag: !hasOneSlide,

      /*
       * Show or hide arrow navigation according to the hero setting.
       */
      arrows: arrows,

      /*
       * Keep Splide pagination enabled so its buttons can serve as the custom
       * progress-bar controls.
       */
      pagination: pagination,

      /*
       * Allow the pagination buttons to be controlled with a keyboard.
       */
      paginationKeyboard: true,

      /*
       * Enable or disable automatic slide advancement.
       */
      autoplay: autoplay,

      /*
       * Set the duration each slide remains visible.
       */
      interval: interval,

      /*
       * Pause autoplay while the visitor hovers over the hero.
       *
       * Splide also pauses its autoplay progress event, so the visual progress
       * bar remains synchronized.
       */
      pauseOnHover: false,

      /*
       * Pause autoplay while an interactive hero element has focus.
       */
      pauseOnFocus: true,

      /*
       * Reset the autoplay timer whenever the active slide changes.
       */
      resetProgress: false,

      /*
       * Set the slide-transition duration.
       */
      speed: 500,

      /*
       * Allow new navigation interactions without forcing the previous
       * transition to finish first.
       */
      waitForTransition: false,

      /*
       * Respect the visitor's reduced-motion preference.
       */
      reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
      }
    });

    /*
     * Return all pagination buttons currently generated by Splide.
     *
     * Splide does not create these elements until its pagination component has
     * mounted, so this function queries them each time they are needed.
     */
    function getPaginationButtons() {
      return Array.from(
        hero.querySelectorAll(
          ".splide__pagination__page"
        )
      );
    }

    /*
     * Update the full-width pagination progress bars.
     *
     * The CSS reads the --gp-hero-progress custom property and uses it to scale
     * the active bar's ::after filling layer from left to right.
     */
    function updateProgressBars(
      activeIndex,
      progress
    ) {
      /*
       * Collect Splide's current pagination buttons.
       */
      const buttons = getPaginationButtons();

      /*
       * Ensure the supplied progress is always between 0 and 1.
       */
      const safeProgress = clamp(
        Number(progress) || 0,
        0,
        1
      );

      /*
       * Update each pagination bar according to its position relative to the
       * current slide.
       */
      buttons.forEach(function (button, index) {
        /*
         * Any slide before the active slide is considered completed during the
         * current carousel cycle.
         */
        const isComplete = index < activeIndex;

        /*
         * Identify the pagination bar belonging to the active slide.
         */
        const isActive = index === activeIndex;

        /*
         * Apply or remove the completed-state class.
         *
         * The completed-state color is controlled through:
         *
         * --gp-hero-progress-filled-color
         */
        button.classList.toggle(
          "is-complete",
          isComplete
        );

        /*
         * Update the active bar with the live autoplay percentage.
         */
        if (isActive) {
          button.style.setProperty(
            "--gp-hero-progress",
            String(safeProgress)
          );
        } else {
          /*
           * Inactive future bars remain empty.
           *
           * Completed bars are filled through their .is-complete CSS class.
           */
          button.style.setProperty(
            "--gp-hero-progress",
            "0"
          );
        }
      });
    }

    /*
     * Initialize the progress bars as soon as Splide creates its pagination.
     */
    splide.on(
      "pagination:mounted",
      function () {
        /*
         * When autoplay is enabled, begin the active bar at zero.
         *
         * When autoplay is disabled, leave the active bar fully filled so the
         * visitor can still identify the selected slide.
         */
        updateProgressBars(
          splide.index,
          autoplay ? 0 : 1
        );
      }
    );

    /*
     * Synchronize the active progress bar with Splide's real autoplay timer.
     *
     * Splide supplies a rate between 0 and 1:
     *
     * 0   = the autoplay interval has just begun
     * 0.5 = half of the interval has elapsed
     * 1   = Splide is ready to advance
     */
    splide.on(
      "autoplay:playing",
      function (rate) {
        updateProgressBars(
          splide.index,
          rate
        );
      }
    );

    /*
     * Reset and rearrange the progress bars as soon as movement toward another
     * slide begins.
     *
     * This covers:
     *
     * - Autoplay
     * - Arrow clicks
     * - Pagination clicks
     * - Swipe/drag navigation
     */
    splide.on(
      "move",
      function (newIndex) {
        updateProgressBars(
          newIndex,
          autoplay ? 0 : 1
        );
      }
    );

    /*
     * Confirm the progress-bar state when the slide transition finishes.
     */
    splide.on(
      "moved",
      function (newIndex) {
        updateProgressBars(
          newIndex,
          autoplay ? 0 : 1
        );
      }
    );

    /*
     * Load the active slide and prepare the next slide whenever the carousel
     * mounts or begins moving.
     */
    splide.on(
      "mounted move",
      function (newIndex) {
        /*
         * Some Splide events provide the new index directly while the mounted
         * event requires reading Splide's current index.
         */
        const activeIndex =
          Number.isInteger(newIndex)
            ? newIndex
            : splide.index;

        /*
         * Activate the current slide's deferred image if necessary.
         */
        activateDeferredPicture(
          slides[activeIndex],
          splide
        );

        /*
         * Prepare the following slide during an idle period.
         */
        prepareNextSlide(
          slides,
          activeIndex,
          rewind,
          splide
        );
      }
    );

    /*
     * Mount Splide after all required event listeners have been registered.
     */
    splide.mount();
  }

  /*
   * Initialize every qualifying homepage hero on the current page.
   *
   * Return true once Splide is available, even when no matching heroes exist.
   */
  function initializeAllHeroes() {
    /*
     * Tell the retry system that Splide is not ready yet.
     */
    if (typeof window.Splide !== "function") {
      return false;
    }

    /*
     * Initialize every hero that has not already been mounted.
     */
    document
      .querySelectorAll(heroSelector)
      .forEach(initializeHero);

    /*
     * Tell the retry system that Splide was successfully found.
     */
    return true;
  }

  /*
   * Wait for the deferred Splide script to become available.
   */
  function waitForSplide(attempt) {
    /*
     * Stop retrying as soon as initialization succeeds.
     */
    if (initializeAllHeroes()) return;

    /*
     * Stop after 50 attempts.
     *
     * At 100 milliseconds per attempt, this gives Splide approximately five
     * seconds to load.
     */
    if (attempt >= 50) return;

    /*
     * Try again after 100 milliseconds.
     */
    window.setTimeout(function () {
      waitForSplide(attempt + 1);
    }, 100);
  }

  /*
   * Begin the Splide availability check.
   */
  function start() {
    waitForSplide(0);
  }

  /*
   * Wait for DOMContentLoaded when the page is still being parsed.
   */
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      { once: true }
    );
  } else {
    /*
     * Initialize immediately when the DOM is already available.
     */
    start();
  }

  /*
   * Re-run initialization when Shopify dynamically reloads a section in the
   * Theme Editor.
   *
   * Existing heroes are protected from duplicate initialization by the
   * data-gp-hero-initialized attribute.
   */
  document.addEventListener(
    "shopify:section:load",
    start
  );
})();

/*
 * LGND HOME WINNERS MARQUEE
 * Paste this entire block at the bottom of the deferred homepage script.
 */

(function () {
  const selector = "[data-lgnd-winners-marquee]";
  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;
  const canHover = window.matchMedia(
    "(hover: hover) and (pointer: fine)"
  ).matches;

  function mountMarquee(root) {
    if (root.dataset.lgndWinnersInitialized === "true") return;

    root.dataset.lgndWinnersInitialized = "true";

    const splide = new window.Splide(root, {
      type: "loop",
      autoWidth: true,
      gap: "16px",
      drag: "free",
      snap: false,
      arrows: false,
      pagination: false,
      keyboard: false,

      autoScroll: {
        speed:
          Number.parseFloat(root.dataset.autoScrollSpeed) || 0.55,
        autoStart: !reduceMotion,
        pauseOnHover: canHover,
        pauseOnFocus: true
      },

      breakpoints: {
        749: {
          gap: "10px"
        }
      }
    });

    splide.mount({
      AutoScroll: window.splide.Extensions.AutoScroll
    });

    root.lgndWinnersSplide = splide;

    /*
     * Stop the marquee while it is outside the viewport.
     */
    if (!reduceMotion && "IntersectionObserver" in window) {
      const autoScroll = splide.Components.AutoScroll;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            autoScroll.play();
          } else {
            autoScroll.pause();
          }
        },
        {
          rootMargin: "160px 0px"
        }
      );

      observer.observe(root);

      splide.on("destroy", () => {
        observer.disconnect();
      });
    }
  }

  /*
   * Wait for both Splide and its AutoScroll extension.
   */
  function initialize(attempt = 0) {
    const autoScroll =
      window.splide?.Extensions?.AutoScroll;

    if (
      typeof window.Splide !== "function" ||
      !autoScroll
    ) {
      if (attempt < 60) {
        window.setTimeout(() => {
          initialize(attempt + 1);
        }, 100);
      }

      return;
    }

    document
      .querySelectorAll(selector)
      .forEach(mountMarquee);
  }

  initialize();

  /*
   * Support section reloading inside Shopify's Theme Editor.
   */
  document.addEventListener(
    "shopify:section:load",
    () => initialize()
  );

  document.addEventListener(
    "shopify:section:unload",
    (event) => {
      event.target
        .querySelectorAll(selector)
        .forEach((root) => {
          root.lgndWinnersSplide?.destroy(true);
        });
    }
  );
})();